const MS_MEDIUM = {
  id: "MS_MEDIUM",
  value: 0.5,
  stringKey: "noiseSensitivity.level.medium"
};

export default {
  MS_UNKNOWN: MS_MEDIUM,
  MS_VERY_LOW: {
    id: "MS_VERY_LOW",
    value: 0,
    stringKey: "noiseSensitivity.level.veryLow"
  },
  MS_LOW: {
    id: "MS_LOW",
    value: 0.2,
    stringKey: "noiseSensitivity.level.low"
  },
  MS_MEDIUM: MS_MEDIUM,
  MS_HIGH: {
    id: "MS_HIGH",
    value: 0.8,
    stringKey: "noiseSensitivity.level.high"
  },
  MS_VERY_HIGH: {
    id: "MS_VERY_HIGH",
    value: 1.0,
    stringKey: "noiseSensitivity.level.veryHigh"
  }
};
